import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Col,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  Label,
  Row,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from 'reactstrap';
import util from '../../../lib/utils';
import minus from '../../../Res/Icon/minus.png';
import plus from '../../../Res/Icon/plus.png';
import CompanyAutocomplete from '../../CompanyAutocomplete';
import LocationDetails from '../../LocationDetails';
import MultiInput from '../../MultiInput';
import fetchResult from '../../../Res/Icon/Fetch-Results.svg';
import SpinnerCircles from '../../Spinner/SpinerCircles';
import {
  onAddNewLocation,
  onRemoveLocation,
  onUpdateLocation,
  getLocationByCompany,
  getFirmwareVersion,
  updateBoxModelNumber,
  setSuggestionCompany
} from '../../../actions/EpikBoxes';
import DeleteLocationModal from '../../DeleteLocationModal';
import ModelAutoComplete from '../../ModelAutoComplete';
import AddSecurityCodeModal from '../../AddSecurityCodeModal';
import Toggle from '../../Toggle';
import { FIRM_TYPES, MODEM_LIST, MODEL_LIST } from '../../../lib/constants';
import CustomModal from '../../CustomModal';
import ShippingBox from '../EpikBoxDetails/ShippingBox';
import {
  changeBulkBoxSession,
  disableAction,
  disableBulkBoxSession,
  enableAction,
  enableBulkBoxSession,
} from '../../../actions/BoxSessionLogging';
import OptionalDropdownSelect from '../../OptionalDropdownSelect';
import TooltipIcon from '../EpikBoxDetails/TooltipIcon/TooltipIcon';
import './index.css';
import utils from '../../../lib/utils';
import { getPermissionForComponent } from '../../../utils/permissionsUtils';

const CHANGE_COMPANY_WARNING = `Do you want to transfer notes to new company or erase the device notes?`;


const ModemManagementField = ({ label, Field, md = 4, sm = 12 }) => {
  return (
    <Col md={md} sm={sm}>
      <FormGroup row>
        <Label sm={6}>
          {label}
        </Label>
        <Col sm={12}>
          <>{Field}</>
        </Col>
      </FormGroup>
    </Col>
  )
}

class UpdateEpikBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: props.boxDetails.assignedTo.name,
      companyId: props.boxDetails.assignedTo._id,
      locationId: props.boxDetails.locRef.locationId || '',
      accountNumber: props.boxDetails.assignedTo.epikCustomerId,
      removeLocationId: '',
      locationName: '',
      fetchingLocations: false,
      removeModalStatus: false,
      confirmStatus: false,
      selectedType: props.box.myEpik ? FIRM_TYPES[0] : FIRM_TYPES[1],
      dropdownOpen: false,
      modalStatus: false,
      wgKeyStatus: false,
      totalModemValue: props.boxDetails.imei.length,
      approved: false,
      alertCompanyMails: props.boxDetails.alertCompanyMails,
      staticEmails: props.boxDetails.assignedTo.contactEmails || [],
      shippingModal: false,
      firmwareVersion: '-',
      secondaryNotification: false,
      customerProvidedSIM1: props.boxDetails?.customerProvidedSIM1,
      customerProvidedSIM2: props.boxDetails?.customerProvidedSIM2,
      loadingStatus : false,
      updatedDeviceModel : props.box.model ? props.box.model : '',
      batteryReplacedOn: null,
    };
    this.token = localStorage.getItem('jwtToken') || null;
    if (props.user.role !== 'admin') {
      props.getLocationByCompany(this.token, props.boxDetails.assignedTo._id);
    }
  }

  async componentDidMount() {
    const { box, getFirmwareVersion, boxDetails, user } = this.props;
    if (boxDetails.modems.length === 0) {
      this.handleNumModems('add');
    }

    if (!boxDetails?.serialNumber?.startsWith('E-')) {
      const res = await getFirmwareVersion(this.token, boxDetails._id);
      if (res) {
        this.setState({ firmwareVersion: res });
      }
    }

    if (box.myEpik) {
      this.setState({ selectedType: FIRM_TYPES[0] });
    } else {
      this.setState({ selectedType: FIRM_TYPES[1] });
    }
    this.wgkeyFunction();
    const batteryReplacedOn = getPermissionForComponent('batteryReplacedOn', user.permissionsGroup);
    this.setState({ batteryReplacedOn });
  }

  onFormFieldChange = ev => {
    const { name, value: val, checked, type } = ev.target;
    const value = type === 'checkbox' ? checked : val

    const { approved, accountNumber } = this.state;
    const { boxDetails, changeBulkBoxSession, box } = this.props;
    if (name === 'displayName') {
      changeBulkBoxSession(
        ` Display Name changed from ${box?.displayName || '-'} to ${value} `,
        'displayname',
      );
    }
    if (name === 'customerProvidedSIM1'||name === 'customerProvidedSIM2') {
      changeBulkBoxSession(
        ` ${name} changed from ${box?.[name] || '-'} to ${value} `,
        name,
      );
    }

    if (name === 'customerProvidedIp') {
      changeBulkBoxSession(
        ` customer Provided Ip changed from ${box?.customerProvidedIp || '-'} to ${value}`,
        'customerProvidedIp',
      );
    }
    if (name === 'lteIp') {
      changeBulkBoxSession(` LTE IP changed from ${box?.lteIp || '-'} to ${value}`, 'lteIp');
    }
    if (name === 'apuType') {
      changeBulkBoxSession(` Apu Type changed from ${box?.apuType || '-'} to ${value}`, 'apuType');
    }
    if (name === 'lteIp2') {
      changeBulkBoxSession(` LTE IP 2 changed from ${box?.lteIp2 || '-'} to ${value}`, 'lteIp2');
    }

    if (name === 'vpnAddress') {
      changeBulkBoxSession(
        ` VPN Address changed from ${box?.vpnAddress || '-'} to ${value}`,
        'vpnAddress',
      );
    }
    if (value === 'accountNumber') {
      changeBulkBoxSession(
        ` Account Number changed from ${accountNumber || '-'} to ${value}`,
        'accountNumber',
      );
    }

    if (name === 'serialNumber') {
      if (approved) {
        changeBulkBoxSession(
          ` Serial Number changed from ${box?.serialNumber || '-'} to ${value}`,
          'serialNumber',
        );

        this.props.onFormDataChange({ [name]: value });
      } else {
        this.setState({ modalStatus: true });
      }
    } else {
      const notesAction = name === 'assignedTo' ? ev.target.action : ``;
      this.props.onFormDataChange({ [name]: value, notesAction });
    }
  };

  checkSecurityCode = () => {
    this.setState({ approved: true, modalStatus: false });
  };

  handleFocus = ev => {
    ev.target.select();
  };

  onAddressChange = ev => {
    const { name, value } = ev.target;

    const address = {
      ...this.props.boxDetails.address,
      [name]: value,
    };
    this.onFormFieldChange({
      target: {
        name: 'address',
        value: address,
      },
    });
  };

  onAPNChange(apnIndex, ev) {
    const { changeBulkBoxSession } = this.props;

    changeBulkBoxSession('Changed APN', `apn${apnIndex + 1}`);
    const { value } = ev.target;
    const updatedapn = [...this.props.boxDetails.apn];
    updatedapn[apnIndex] = value;
    this.onFormFieldChange({
      target: {
        name: 'apn',
        value: updatedapn,
      },
    });
  }

  onEmailsChange(emails) {
    const { changeBulkBoxSession, box } = this.props;

    changeBulkBoxSession(
      `Email Address changed from ${box?.notifyEmails || '-'} to ${emails}`,
      'emailnotification',
    );
    this.onFormFieldChange({
      target: {
        name: 'notifyEmails',
        value: emails,
      },
    });
  }
  on911EmailsChange(emails) {
    const { changeBulkBoxSession, box } = this.props;

    changeBulkBoxSession(
      `911 Email Address changed from ${box?.emergencyEmails || '-'} to ${emails}`,
      '911emailnotification',
    );
    this.onFormFieldChange({
      target: {
        name: 'emergencyEmails',
        value: emails,
      },
    });
  }

  onSecondaryNotificationEmailsChange(emails) {
    const { changeBulkBoxSession, box } = this.props;
    changeBulkBoxSession(
      `Secondary Notification Email Address changed from ${box?.secondaryNotifyEmails ||
      '-'} to ${emails}`,
      'secondaryemailnotification',
    );
    this.onFormFieldChange({
      target: {
        name: 'secondaryNotifyEmails',
        value: emails,
      },
    });
  }

  onNumbersChange(numbers) {
    const { changeBulkBoxSession, box } = this.props;
    changeBulkBoxSession(
      `Notification Number changed from ${JSON.stringify(box?.notifyNumbers || '-')} to ${numbers}`,
      'notificationnumber',
    );
    this.onFormFieldChange({
      target: {
        name: 'notifyNumbers',
        value: numbers,
      },
    });
  }

  onEmergencyNumbersChange(numbers) {
    const { changeBulkBoxSession, box } = this.props;
    changeBulkBoxSession(
      `Emergency Notification Number changed from ${JSON.stringify(
        box?.emergencyNumbers || '-',
      )} to ${numbers}`,
      'notificationnumber',
    );
    this.onFormFieldChange({
      target: {
        name: 'emergencyNumbers',
        value: numbers,
      },
    });
  }

  onSecondaryNotificationNumbersChange(numbers) {
    const { changeBulkBoxSession, box } = this.props;
    changeBulkBoxSession(
      `Secondary Notification Number changed from ${JSON.stringify(
        box?.secondaryNotifyNumbers || '-',
      )} to ${numbers}`,
      'secondarynotificationnumber',
    );
    this.onFormFieldChange({
      target: {
        name: 'secondaryNotifyNumbers',
        value: numbers,
      },
    });
  }

  onFormItemChange = (ev, modemIndex, phoneIndex = null) => {
    const { value, name } = ev?.target || ev;
    const { changeBulkBoxSession, boxDetails } = this.props;
    const updatedModems = JSON.parse(
      JSON.stringify(boxDetails.modems || [])
    );
    changeBulkBoxSession(
      `Changed ${name || '-'} to ${value}`,
      `${name}${modemIndex + 1}`
    );
    if (name === 'phones') {
      if (!updatedModems[modemIndex].phones) {
        updatedModems[modemIndex].phones = [];
      }
      updatedModems[modemIndex].phones[phoneIndex] = value;
    }
    else if (name === 'sim1') {
      if (!updatedModems[modemIndex].sims) {
        updatedModems[modemIndex].sims = [];
      }
      updatedModems[modemIndex].sims[0] = value;
    }
    else if (name === 'sim2') {
      if (!updatedModems[modemIndex].sims) {
        updatedModems[modemIndex].sims = [];
      }
      updatedModems[modemIndex].sims[1] = value;
    }
    else {
      updatedModems[modemIndex][name] = value;
    }
    this.onFormFieldChange({
      target: {
        name: 'modems',
        value: updatedModems,
      },
    });
    this.props.onFormDataChange({
      modems: updatedModems,
    });
  };

  modemCheck = (modems, index) => {
    if (index === 1 && modems[1].imeis === '') {
      return false;
    }
    return true;
  };
  renderImeiImzi = () => {
    const view = [];
    const { boxDetails } = this.props;
    const { modems } = boxDetails;
    modems.forEach((modem, index) => {
      const modemImei = modem?.imeis;
      const modemType = modem?.type;
      const modemPhone = modem?.phones?.length ? modem?.phones[index] : ``;
      const modemSim1 = modem?.sims?.length ? modem?.sims[0] : '';
      const modemSim2 = modem?.sims?.length ? modem?.sims[1] : '';

      // eslint-disable-next-line no-unused-expressions
      this.modemCheck(modems, index) &&
        view.push(
          <>
            {/* <h1 className="modem-number">{`Modem ${modems.length > 1 ? index + 1 : ''}`}</h1> */}
            <div key={`imeiimsi${index}`}>
              <Row>
                <ModemManagementField
                  label={'Modem Type'}
                  Field=
                  {
                    <OptionalDropdownSelect
                      isDisabled={boxDetails.editStatus}
                      placeholder="Filter Model"
                      nameTag="type"
                      filterTag="name"
                      dropdownList={MODEM_LIST}
                      searchTerm={modemType || ''}
                      onChange={e => this.onFormItemChange(e, index)}
                    />
                  }
                />
                <ModemManagementField
                  label={'IMEI'}
                  Field=
                  {
                    <Input
                      disabled={boxDetails.editStatus}
                      required
                      type="text"
                      name={`imeis`}
                      value={modemImei || ''}
                      placeholder="Set box imei"
                      onFocus={this.handleFocus}
                      onChange={e => this.onFormItemChange(e, index)}
                    />
                  }
                />
                <ModemManagementField
                  label={'Phone'}
                  Field=
                  {
                    <Input
                      disabled={boxDetails.editStatus}
                      required
                      type="text"
                      name={`phones`}
                      value={modemPhone || ''}
                      placeholder="Set box Phone"
                      onFocus={this.handleFocus}
                      onChange={e => this.onFormItemChange(e, index)}
                    />
                  }
                />
              </Row>
              {/* <Row>
                <Col md={6}>
                  <Row>
                    <ModemManagementField
                      md={12}
                      label={'SIM 1'}
                      Field={
                        <Input
                          disabled={boxDetails.editStatus}
                          required
                          type="text"
                          name={`sim1`}
                          value={modemSim1 || ''}
                          placeholder="Set box Phone"
                          onFocus={this.handleFocus}
                          onChange={e => this.onFormItemChange(e, index)}
                        />
                      }
                    />

                    <Col md={1} sm={1}></Col>
                    <Col md={11} sm={11}>
                      <Input
                        disabled={boxDetails.editStatus}
                        type="checkbox"
                        name={`customerProvideSIM1`}
                        checked={boxDetails.customerProvideSIM1}
                        onChange={this.onFormFieldChange}
                      />
                      <Label>
                        Customer Provided Sim
                      </Label>
                    </Col>
                  </Row>
                </Col>

                <Col md={6}>
                  <Row>
                    <ModemManagementField
                      md={12}
                      label={'SIM 2'}
                      Field=
                      {
                        <Input
                          disabled={boxDetails.editStatus}
                          required
                          type="text"
                          name="sim2"
                          value={modemSim2 || ''}
                          placeholder="Set box Phone"
                          onFocus={this.handleFocus}
                          onChange={e => this.onFormItemChange(e, index)}
                        />
                      }
                    />
                    <Col md={1} sm={1}></Col>
                    <Col md={11} sm={11}>
                      <Input
                        disabled={boxDetails.editStatus}
                        type="checkbox"
                        name={`customerProvideSIM2`}
                        checked={boxDetails.customerProvideSIM2}
                        onChange={this.onFormFieldChange}
                      />
                      <Label>
                        Customer Provided Sim
                      </Label>
                    </Col>
                  </Row>
                </Col>
              </Row> */}


            </div>
          </>,
        );
    });
    return view;
  };

  renderSim1Fields() {
    const view = [];
    const { boxDetails } = this.props;
    const { modems } = boxDetails;

    modems.forEach((modem, index) => {
      const modemSim1 = modem?.sims?.[0] || '';

      if (this.modemCheck(modems, index)) {
        view.push(
          <div key={`sim-fields-${index}`}>
            <Row>
              <ModemManagementField
                md={12}
                label={'SIM 1'}
                Field={
                  <Input
                    disabled={boxDetails.editStatus}
                    required
                    type="text"
                    name={`sim1`}
                    value={modemSim1 || ''}
                    placeholder="Set box Sim"
                    onFocus={this.handleFocus}
                    onChange={e => this.onFormItemChange(e, index)}
                  />
                }
              />
              <Col style={{ paddingLeft: '40px' }}>
                <Input
                  disabled={boxDetails.editStatus}
                  type="checkbox"
                  name={`customerProvideSIM1`}
                  checked={boxDetails.customerProvideSIM1}
                  onChange={this.onFormFieldChange}
                />

                <Label>
                  Customer Provided Sim
                </Label>
              </Col>
            </Row>

          </div>
        );
      }
    });

    return view;
  }

  renderSim2Fields() {
    const view = [];
    const { boxDetails } = this.props;
    const { modems } = boxDetails;

    modems.forEach((modem, index) => {
      const modemSim2 = modem?.sims?.length ? modem?.sims[1] : '';

      if (this.modemCheck(modems, index)) {
        view.push(
          <div key={`sim-fields-${index}`}>
            <Row>
              <ModemManagementField
                md={12}
                label={'SIM 2'}
                Field={
                  <Input
                    disabled={boxDetails.editStatus}
                    required
                    type="text"
                    name={`sim2`}
                    value={modemSim2 || ''}
                    placeholder="Set box Sim 2"
                    onFocus={this.handleFocus}
                    onChange={e => this.onFormItemChange(e, index)}
                  />
                }
              />
              <Col style={{ paddingLeft: '40px' }}>
                <Input
                  disabled={boxDetails.editStatus}
                  type="checkbox"
                  name={`customerProvideSIM1`}
                  checked={boxDetails.customerProvideSIM1}
                  onChange={this.onFormFieldChange}
                />
                <Label>
                  Customer Provided Sim
                </Label>

              </Col>
            </Row>
          </div >
        );
      }
    });

    return view;
  }

  handleNumModems = e => {
    const { boxDetails } = this.props;
    const modemObj = { imeis: '', label: '', phones: [], sims: [], type: '' };
    let updatedModems = [...boxDetails.modems];
    let value;
    if (e === 'add') {
      // concat modemObj to updatedModems array
      updatedModems = updatedModems.concat(modemObj);
      value = boxDetails.numberOfModems + 1;
    } else {
      // remove last object from updatedModems array
      updatedModems.pop();
      value = boxDetails.numberOfModems - 1;
    }
    this.onNumberChange({
      target: {
        name: 'numberOfModems',
        value,
      },
    });
    this.props.onFormDataChange({ modems: updatedModems });
  };

  onNumberChange = ev => {
    const { name, value } = ev.target;
    const { boxDetails } = this.props;
    this.setState({ totalModemValue: value });
    if (value >= 3) {
      return this.onFormFieldChange({
        target: {
          name,
          value: 2,
        },
      });
    }

    try {
      const numberValue = name === 'modems' ? value : value >= 0 ? value : 0;
      boxDetails.imsi = boxDetails.imsi.slice(0, numberValue);
      boxDetails.imei = boxDetails.imei.slice(0, numberValue);
      boxDetails.modemPhone = boxDetails.imei.slice(0, numberValue);
      boxDetails.modems = value;
      boxDetails.apn = boxDetails.imei.slice(0, numberValue);
      this.onFormFieldChange({
        target: {
          name,
          value: numberValue,
        },
      });
    } catch (e) {
      console.error('Cannot parse num modems in update box');
    }
  };

  onCompanyChange = async ({ name, value, suggestion, action }) => {
    const { getLocationByCompany, box } = this.props;
    if (suggestion !== null) {
      this.setState({ fetchingLocations: true });
      await getLocationByCompany(this.token, suggestion?._id);
      this.setState({ fetchingLocations: false });

      this.props.changeBulkBoxSession(
        `changed company name from ${box?.assignedTo?.name || '-'} to ${suggestion.name}`,
        'Company',
      );
      this.setState({ staticEmails: suggestion.contactEmails });
      this.onFormFieldChange({
        target: {
          name: 'assignedTo',
          value: suggestion._id,
          action,
        },
      });

      this.setState({
        searchTerm: suggestion.name,
        companyId: suggestion._id,
        accountNumber: suggestion.epikCustomerId,
      });
      // this.setState({suggestionComany:suggestion})
      await setSuggestionCompany(suggestion)
    }
  };

  createNewLocation = async ev => {
    const { name: locationName } = ev.address;
    const { companyId } = this.state;
    const { onAddNewLocation, getLocationByCompany } = this.props;
    const res = await onAddNewLocation(this.token, companyId, ev);
    if (res) {
      await getLocationByCompany(this.token, companyId);
      const newLocation = await this.props.locations.find(location => {
        return location.locationName === locationName;
      })
      console.log('newloc______', newLocation);

      const target = {
        name: 'locRef',
        value: newLocation?._id,
      };
      this.setState({ locationId: newLocation?.locationId });
      this.onFormFieldChange({ target });
    }
  };

  updateLocation = async ev => {
    const { onUpdateLocation, getLocationByCompany, locations, changeBulkBoxSession } = this.props;
    changeBulkBoxSession(`Location updated`, 'Location');
    const { companyId } = this.state;
    const res = await onUpdateLocation(this.token, companyId, ev);
    if (res) {
      await getLocationByCompany(this.token, companyId);
    }
  };

  onRemoveLocation = async () => {
    const { companyId, removeLocationId } = this.state;
    const { onRemoveLocation, getLocationByCompany } = this.props;
    const res = await onRemoveLocation(this.token, removeLocationId);
    if (res) {
      await getLocationByCompany(this.token, companyId);
      this.setState({ removeModalStatus: false, confirmStatus: true });
    }
  };

  selectLocation = e => {
    this.props.changeBulkBoxSession(
      ` Location Updated from ${this.props.boxDetails?.locRef?.locationName || '-'} to ${e.locationName
      }`,
      'locationUpdated',
    );
    const target = {
      name: 'locRef',
      value: e._id,
    };
    this.setState({ locationId: e.locationId, locationName: e.locationName });
    this.onFormFieldChange({ target });
  };

  onRemovePress = e => {
    this.setState({ removeLocationId: e, removeModalStatus: true });
  };

  onCancelRemoveModal = () => {
    this.setState({ removeModalStatus: false, confirmStatus: false });
  };

  onModelFilter = e => {
    const { box } = this.props;
    this.props.changeBulkBoxSession(
      ` Edge Device Model Changed from ${box?.model || '-'} to ${e.value === null ? '' : e.value} `,
      'edgedevice',
    );
    this.props.onFormDataChange({ [e.name]: e.value === null ? '' : e.value });
  };

  handleSecNotifyToggle = () => {
    const { boxDetails } = this.props;
    const current = !!boxDetails?.secondaryNotification;
    this.props.changeBulkBoxSession(
      ` Secondary Notification Changed from ${current} to ${!current}`,
      'secondaryNotification',
    );
    this.props.onFormDataChange({ secondaryNotification: !current });
  };
  handleRefreshModelNumber = async () =>{
    const { boxDetails, updateBoxModelNumber, getBoxData} = this.props;
    const vpnAddress  = boxDetails?.vpnAddress
    this.setState({ loadingStatus: true });
    const resp = await updateBoxModelNumber(this.token, vpnAddress);
    if(resp){
      await getBoxData()
      this.setState({ loadingStatus: false });
      this.setState({ updatedDeviceModel : this.props.box.model })
    }else{
      this.setState({ loadingStatus: false });
      this.setState({ updatedDeviceModel : this.props.box.model })
    }
  }

  onTypeSelect = firmType => {
    const { firmSelectedType } = this.props;
    this.props.changeBulkBoxSession(
      ` Firmware Changed from ${this.state?.selectedType?.label} to ${firmType?.label}`,
      'firmware',
    );
    firmSelectedType(firmType);
  };

  renderTypes = () => {
    const { selectedType } = this.state;
    return FIRM_TYPES.map(firmType => {
      return (
        <DropdownItem key={firmType.value} onClick={() => this.onTypeSelect(firmType)}>
          {firmType.label}
        </DropdownItem>
      );
    });
  };

  toggle = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  wgkeyFunction = () => {
    const { boxDetails, user } = this.props;
    if (!boxDetails.wgPublicKey) {
      this.setState({ wgKeyStatus: true });
    } else if (boxDetails.wgPublicKey && user.role === 'superAdmin') {
      this.setState({ wgKeyStatus: true });
    } else {
      this.setState({ wgKeyStatus: false });
    }
  };

  lteIp2Enable = () => {
    const { boxDetails } = this.props;
    if (
      boxDetails?.modems?.length === 1 &&
      boxDetails?.modems[0]?.sims?.length &&
      boxDetails?.modems[0]?.sims[1]
    ) {
      return true;
    }
    if (
      boxDetails?.modems?.length === 2 &&
      boxDetails?.modems[1]?.sims?.length &&
      boxDetails.modems[1]?.sims[0]
    ) {
      return true;
    }
    return false;
  };

  dialPlanValue = () => {
    const { box } = this.props;
    if (box?.advancedRouting) {
      return 'Enhanced Routing';
    } else {
      if (box?.myEpik) {
        return 'Standard';
      } else {
        if (box?.boxRegistrar?.toLowerCase() === "unified") {
          return 'Unified';
        } else if (box?.boxRegistrar?.toLowerCase() === "midregistrar") {
          return 'Load Balancer';
        }
      }
    }
  }

  render() {
    const { boxDetails, user, box, companies,boxData } = this.props;
    const {
      locationId,
      accountNumber,
      locationName,
      removeModalStatus,
      confirmStatus,
      selectedType,
      dropdownOpen,
      wgKeyStatus,
      totalModemValue,
      companyId,
      alertCompanyMails,
      staticEmails,
      shippingModal,
      firmwareVersion,
      searchTerm,
      batteryReplacedOn
    } = this.state;
    const creationDate = new Date(box.creationDate) || new Date();
    const isESeries = boxDetails?.serialNumber && boxDetails?.serialNumber?.startsWith('E-')

    const secureInfo = getPermissionForComponent('secureInfo', user.permissionsGroup);
    const secondaryNotificationPerm = getPermissionForComponent(
      'secondaryNotification',
      user.permissionsGroup,
    );

    const secondaryNotifyReadOnly =
      secondaryNotificationPerm === 'read' ||
      boxDetails.editStatus;

    return (
      <div className="container">
        <Row>
          <Col md={4} sm={12}>
            <FormGroup row>
              <Label for="displayName" sm={8} id="label-displayName" >
                Display Name
              </Label>
              <Col md={12} sm={12}>
                <Input
                  id="displayName"
                  aria-labelledby="label-displayName"
                  readOnly={boxDetails.editStatus}
                  required
                  type="text"
                  name="displayName"
                  placeholder="Enter Display Name"
                  value={boxDetails.displayName}
                  onFocus={this.handleFocus}
                  onChange={this.onFormFieldChange}
                />
              </Col>
            </FormGroup>
          </Col>

          <Col md={4} sm={12}>
            <FormGroup row>
              <Label for="serialNumber" id='serialNumber' sm={8}>
                Serial Number
              </Label>
              <Col sm={12}>
                <Input
                 id='serialNumber'
                  readOnly={boxDetails.editStatus}
                  required
                  type="text"
                  name="serialNumber"
                  placeholder="Enter Serial Number"
                  value={boxDetails.serialNumber}
                  onFocus={this.handleFocus}
                  onChange={this.onFormFieldChange}
                />
              </Col>
            </FormGroup>
          </Col>
          <Col md={2} sm={12}>
            <Label for="numberOfModems" id='label-firmware' sm={12}>
              Firmware
            </Label>
            <Col sm={12}>
              <Input type="text" readOnly value={boxDetails?.fwVersion || firmwareVersion} id='firmware' />
            </Col>
          </Col>
          {/* <Col md={12} sm={12}> */}
          {/* <Label for="numModems" sm={12}>
              Dial plan :
            </Label> */}
          <Col md={2} sm={12}>
            <FormGroup row>
              <Label for="numModems" id='label-dialPlan' sm={12}>
                Dial Plan
              </Label>
              <Col sm={12}>
                <Input readOnly value={this.dialPlanValue()} id="dialPlan" />
              </Col>
            </FormGroup>
            {/* <Dropdown name="type" isOpen={dropdownOpen} toggle={this.toggle}>
                <DropdownToggle disabled={false} caret>
                  {selectedType?.label}
                </DropdownToggle>
                <DropdownMenu>{this.renderTypes()}</DropdownMenu>
              </Dropdown> */}
          </Col>
          {/* </Col> */}
        </Row>

        <Row>
          <Col md={4} sm={12}>
            <FormGroup row>
              <Label for="customerProvidedIp" sm={12} id='label-customerProvidedIp'>
                Static IP Address
              </Label>
              <Col sm={12}>
                <Input
                 id='customerProvidedIp'
                  readOnly={boxDetails.editStatus}
                  required
                  placeholder="Please specify"
                  type="text"
                  name="customerProvidedIp"
                  value={boxDetails.customerProvidedIp}
                  onChange={this.onFormFieldChange}
                />
              </Col>
            </FormGroup>
          </Col>
          {/* <Col md={3} sm={12}>
            <FormGroup row>
              <Label for="lteIp" sm={6}>
                LTE IP
              </Label>
              <Col sm={12}>
                <Input
                  disabled={boxDetails.editStatus}
                  required
                  placeholder="Please specify"
                  type="text"
                  name="lteIp"
                  value={boxDetails.lteIp}
                  onChange={this.onFormFieldChange}
                />
              </Col>
            </FormGroup>
          </Col> */}
          {/* {this.lteIp2Enable() && (
            <Col md={3} sm={12}>
              <FormGroup row>
                <Label for="lteIp" sm={6}>
                  LTE IP 2
                </Label>
                <Col sm={12}>
                  <Input
                    disabled={boxDetails.editStatus}
                    required
                    placeholder="Please specify"
                    type="text"
                    name="lteIp2"
                    value={boxDetails.lteIp2}
                    onChange={this.onFormFieldChange}
                  />
                </Col>
              </FormGroup>
            </Col>
          )} */}
          <Col md={4} sm={12}>
            <FormGroup row>
              <Label for="createdOn" sm={12} id='label-createdOn'>
                Created On
              </Label>
              <Col sm={12}>
                <Input readOnly value={creationDate.toLocaleDateString()} id='createdOn' />
              </Col>
            </FormGroup>
          </Col>
          {batteryReplacedOn &&
            <Col md={4} sm={12}>
              <FormGroup row>
                <Label for="batteryReplacedOn" id='lbl-batteryReplacedOn' sm={12}>
                  Battery Replaced On
                </Label>
                <Col sm={12}>
                  <Input 
                  id='batteryReplacedOn'
                    readOnly={batteryReplacedOn === 'read'}
                    type="date"
                    name="batteryReplacedOn"
                    value={
                      boxDetails?.batteryReplacedOn
                        ? boxDetails.batteryReplacedOn.slice(0, 10)
                        : ''
                    }
                        onChange={this.onFormFieldChange}
                  />
                </Col>
              </FormGroup>
            </Col>
          }
        </Row>
        <Row>
          <Col md={4} sm={12}>
            <FormGroup row>
              <Label for="vpnAddress" sm={12} id='lbl-vpnAddress'>
                EPIK Edge Address
              </Label>
              <Col sm={12}>
                <Input
                 id= 'vpnAddress'
                  readOnly={boxDetails.editStatus}
                  required
                  placeholder="Specify"
                  type="text"
                  name="vpnAddress"
                  value={boxDetails?.vpnAddress || ''}
                  onChange={this.onFormFieldChange}
                />
              </Col>
            </FormGroup>
          </Col>
          <Col md={3} sm={12}>
            <FormGroup row>
              <Label for="model" sm={12} id='label-model'>
                Edge Device Model
              </Label>
              <Row>
                <Col sm={!boxDetails.editStatus ? 9 : 12} style={{ paddingLeft: '30px', paddingRight: '30px', }}>
                  <ModelAutoComplete
                    editStatus={boxDetails.editStatus}
                    placeholder="Filter Model"
                    models={MODEL_LIST}
                  searchTerm={ this.state.loadingStatus ? 'fetching...' : this.state.updatedDeviceModel }
                    onChange={this.onModelFilter}
                  />
                </Col>
                {
                  !boxDetails.editStatus && !boxDetails?.serialNumber?.startsWith('E-') &&
                  <>
                    <Col sm={3}>
                      {
                        this.state.loadingStatus ? (
                          <div className="refresh-model-number-spinner">
                            <SpinnerCircles red />
                          </div>
                        ) : (
                          <TooltipIcon
                            tipId="Refresh"
                            customClass="refresh-model-number"
                            onClick={() => {
                              this.handleRefreshModelNumber();
                            }}
                            imgSrc={fetchResult}
                            displayData="Refresh Model Number"
                          />
                        )
                      }
                    </Col>
                  </>
                }
              </Row>

            </FormGroup>
          </Col>

          <Col md={2} sm={12}>
            <FormGroup>
              <Label for="revision" sm={12} id='label-rev'>
                Rev.
              </Label>
              <Col sm={12}>
                <Input
                  id='revision'
                  readOnly={boxDetails.editStatus}
                  placeholder=""
                  type="text"
                  name="revision"
                  value={boxDetails?.revision || ''}
                  onChange={this.onFormFieldChange}
                />
              </Col>
            </FormGroup>
          </Col>

          <Col md={2} sm={12}>
            <FormGroup>
              <Label for="model" sm={12} id='lbl-apuType'>
                APU Type
              </Label>
              <Col sm={12}>
                <Input
                id= 'apuType'
                  required
                  placeholder="Specify"
                  type="text"
                  name="apuType"
                  value={boxDetails.apuType}
                  onChange={this.onFormFieldChange}
                />
              </Col>
            </FormGroup>
          </Col>
        </Row>
        {
          !isESeries ?
            <Row className="modems-container">
              <Col md={12} lg={12} xs={12} sm={12}>
                {/* <hr /> */}
                <h1 className="modem-text pt-2" style={{ textAlign: "left", textDecoration: "none" }}>Modem Management</h1>
                <hr />
              </Col>
              {/* <Col md={2} sm={12}>
            <FormGroup row>
              <Label for="numModems" sm={12}>
                Total Modems:
              </Label>
              <Col sm={12} className="totalModemInput">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <img
                      className="modemAdd-icon"
                      src={plus}
                      alt="add"
                      onClick={() => this.handleNumModems('add')}
                    />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  disabled={boxDetails.editStatus}
                  autoComplete="off"
                  required
                  type="number"
                  min="0"
                  max="1"
                  name="numberOfModems"
                  placeholder="0"
                  value={boxDetails.numberOfModems}
                  onFocus={this.handleFocus}
                  onChange={this.onNumberChange}
                />
                <InputGroupAddon addonType="append">
                  <InputGroupText>
                    <img
                      className="modemAdd-icon"
                      src={minus}
                      alt="remove"
                      onClick={() => this.handleNumModems('sub')}
                    />
                  </InputGroupText>
                </InputGroupAddon>
              </Col>
            </FormGroup>
          </Col> */}
              <Col>
                {this.renderImeiImzi()}
                {/* <hr /> */}
              </Col>
            </Row> :
            <Row>
              <Col md={12} sm={12}>
                <hr />
              </Col>
            </Row>
        }
        <Row>
          <Col md={12} sm={12}>
            <h1 className="modem-text pt-2" style={{ textAlign: "left", textDecoration: "none" }}>Active Sim</h1>
            <hr />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Row>
              <ModemManagementField
                md={12}
                label={'Sim Status'}
                Field=
                {
                  <Input
                  id='simStatus'
                   readOnly
                    required
                    type="text"
                    name={`simStatus`}
                    value="Active"
                    placeholder="Set box sim status"
                  />
                }
              />
            </Row>
          </Col>

          <Col md={6}>
            <Row>
              <ModemManagementField
                md={12}
                label={'SIM'}
                Field=
                {
                  <Input
                  id='simValue'
                    readOnly
                    required
                    type="text"
                    name={`simValue`}
                    value={
                      box?.activeLTE?.[1]?.sim 
                        ? box.activeLTE[1].sim 
                        :boxData?.activeLTE?.[1]?.sim || ''
                    }
                    placeholder="--"
                  />
                }
              />
            </Row>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Row>
              <ModemManagementField
                md={12}
                label={'IP Address'}
                Field=
                {
                  <Input
                    readOnly
                    required
                    type="text"
                    name={`ipAddress`}
                    value={
                      box?.activeLTE?.[1]?.ip 
                        ? box.activeLTE[1].ip 
                        :boxData?.activeLTE?.[1]?.ip || ''
                    }
                    placeholder="Please specify"
                  />
                }
              />
            </Row>
          </Col>

          <Col md={6}>
            <Row>
              <ModemManagementField
                md={12}
                label={'IMEI'}
                Field=
                {
                  <Input
                  id='imei'
                    readOnly
                    required
                    type="text"
                    name={`imei`}
                    value={
                      box?.activeLTE?.[1]?.imei 
                        ? box.activeLTE[1].imei 
                        :boxData?.activeLTE?.[1]?.imei || ''
                    }
                    placeholder="Set box imei"
                  />
                }
              />
            </Row>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Row>
              <ModemManagementField
                md={12}
                label={'Time stamp'}
                Field=
                {
                  <Input
                  id='timeStamp'
                    readOnly
                    required
                    type="text"
                    name={`timeStamp`}
                    style={box?.activeLTE?.[1]?.timeStamp && utils.isOlderThan24Hours(box.activeLTE[1].timeStamp) ? { color: 'red', fontWeight: 500 } : {}}
                    value={
                      box?.activeLTE?.[1]?.timeStamp
                        ? utils.getDateTimeFormat(box.activeLTE[1].timeStamp, 'both')
                        : boxData?.activeLTE?.[1]?.timeStamp || ''
                    }
                  />
                }
              />
            </Row>
          </Col>

          <Col md={6}>
            <Row>
              <ModemManagementField
                md={12}
                label={'MTN'}
                Field=
                {
                  <Input
                  id='mtn'
                   readOnly
                    required
                    type="text"
                    name={`mtn`}
                    value={
                      box?.activeLTE?.[1]?.mtn 
                        ? box.activeLTE[1].mtn 
                        :boxData?.activeLTE?.[1]?.mtn || ''
                    }
                    placeholder="Set box mtn"
                  />
                }
              />
            </Row>
          </Col>
        </Row>

        <Row>
          <Col md={12} sm={12}>
            <hr />
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            {this.renderSim1Fields()}
          </Col>
          <Col md={6}>
            <Row>
              <ModemManagementField
                md={12}
                label={'IMEI'}
                Field=
                {
                  <Input
                  id='imei'
                    readOnly
                    required
                    type="text"
                    name={`imei`}
                    value={boxDetails?.modems[0]?.imeis}
                    placeholder="Set box imei"
                  />
                }
              />
            </Row>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Row>
              <ModemManagementField
                md={12}
                label={'MTN 1'}
                Field=
                {
                  <Input
                    disabled={boxDetails.editStatus}
                 id='mtn'
                    required
                    type="text"
                    name="phones"
                    value={
                      boxDetails?.modems?.[0]?.phones?.[0] || ''
                    }
                    onChange={(e) => this.onFormItemChange(e, 0, 0)}
                    placeholder="Set box mtn"
                  />
                }
              />
            </Row>
          </Col>
          {(secureInfo === 'both' || secureInfo === 'read') && (
            <Col md={6}>
              <FormGroup row>
                <Label for="lteIp" sm={6}>
                  LTE IP 1
                </Label>
                <Col sm={12}>
                  <Input
                  id='lteIp'
                    readOnly={boxDetails.editStatus || secureInfo === 'read'}
                    required
                    placeholder="Please specify"
                    type="text"
                    name="lteIp"
                    value={boxDetails.lteIp}
                    onChange={this.onFormFieldChange}
                  />
                </Col>
              </FormGroup>
            </Col>
          )}
        </Row>

        <Row>
          <Col md={12} sm={12}>
            <hr />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            {this.renderSim2Fields()}
          </Col>
          <Col md={6}>
            <Row>
              <ModemManagementField
                md={12}
                label={'IMEI'}
                Field=
                {
                  <Input
                  id= 'imei'
                  readOnly
                    required
                    type="text"
                    name={`imei`}
                    value={boxDetails?.modems[0]?.imeis}
                    placeholder="Set box imei"

                  />
                }
              />
            </Row>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Row>
              <ModemManagementField
                md={12}
                label={'MTN 2'}
                Field=
                {
                  <Input
                    disabled={boxDetails.editStatus}
                    required
                    type="text"
                    name="phones"
                    value={
                      boxDetails?.modems?.[0]?.phones?.[1] || ''
                    }
                    onChange={(e) => this.onFormItemChange(e, 0, 1)}
                    placeholder="Set box mtn"
                  />
                }
              />
            </Row>
          </Col>
          {(secureInfo === 'both' || secureInfo === 'read') && (
            <Col md={6} >
              <FormGroup row>
                <Label for="lteIp" sm={6}>
                  LTE IP 2
                </Label>
                <Col sm={12}>
                  <Input
                    readOnly={boxDetails.editStatus || secureInfo === 'read'}
                    required
                    placeholder="Please specify"
                    type="text"
                    name="lteIp2"
                    value={boxDetails.lteIp2}
                    onChange={this.onFormFieldChange}
                  />
                </Col>
              </FormGroup>
            </Col>
          )}
        </Row>
        <Row>
          <Col md={12} sm={12}>
            <hr />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup row>
              <Label for="assignedTo" sm={6} id="label-assignedTo">
                Account Number:
              </Label>
              <Col sm={12}>
                <Input
                 id = 'accountNumber'
                  required
                  placeholder="Not specified"
                  type="text"
                  readOnly
                  value={accountNumber}
                  onChange={this.onFormFieldChange}
                />
              </Col>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup row>
              <Label for="companyName" sm={6} id="label-companyName">
                Company:
              </Label>
              <Col sm={12}>
                {user.role === 'admin' || user.role === 'enterpriseAdmin' ? (
                  <Input
                   id  = 'companyName'
                    type="text"
                    disabled
                    value={user?.company?.name || boxDetails.editStatus}
                  />
                ) : (
                  <CompanyAutocomplete
                    editStatus={
                      boxDetails.editStatus || user?.company.companyType === 'manufacturer'
                    }
                    searchTerm={searchTerm || ''}
                    companies={companies.docs}
                    onChange={this.onCompanyChange}
                    showWarning
                    warningText={CHANGE_COMPANY_WARNING}
                  />
                )}
              </Col>
            </FormGroup>
          </Col>
        </Row>

        <Row>
          {/* <Col md={3} sm={12}>
            <FormGroup row>
              <Label for="assignedTo" sm={6}>
                Company:
              </Label>
              <Col sm={12}>
                {user.role === 'admin' || user.role === 'enterpriseAdmin' ? (
                  <Input
                    type="text"
                    disabled
                    value={user?.company?.name || boxDetails.editStatus}
                  />
                ) : (
                  <CompanyAutocomplete
                    editStatus={
                      boxDetails.editStatus || user?.company.companyType === 'manufacturer'
                    }
                    searchTerm={searchTerm || ''}
                    companies={companies.docs}
                    onChange={this.onCompanyChange}
                    showWarning
                    warningText={CHANGE_COMPANY_WARNING}
                  />
                )}
              </Col>
            </FormGroup>
          </Col> */}

          {this.props.boxDetails.assignedTo !== '' && (
            <>
              <Col md={6}>
                <FormGroup row>
                  <Label for="address" sm={6}>
                    Location
                  </Label>
                  <Col sm={12}>
                    <LocationDetails
                      disabledAdmin={
                        user.role === 'admin' ||
                        user.role === 'enterpriseAdmin' ||
                        boxDetails.editStatus
                      }
                      defaultSelected={this.props.boxDetails.locRef}
                      selectLocation={this.selectLocation}
                      locations={this.props.locations}
                      onRemoveLocation={this.onRemovePress}
                      createNewLocation={this.createNewLocation}
                      updateLocation={this.updateLocation}
                      onRemoveConfirm={confirmStatus}
                      fetchingLocations={this.state.fetchingLocations}
                    />
                  </Col>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup row>
                  <Label for="locationId" sm={6} id  = 'label-locationId'>
                    Location ID
                  </Label>
                  <Col sm={12}>
                    <Input type="text" disabled value={locationId} id = 'locationId' />
                  </Col>
                </FormGroup>
              </Col>
            </>
          )}
        </Row>

        <Row>
          <Col md={6} >
            <FormGroup row>
              <Label for="emails" sm={6}>
                Notification email(s)
              </Label>
              <Col sm={12}>
                <MultiInput
                  disabledAdmin={
                    user.role === 'admin' ||
                    user.role === 'enterpriseAdmin' ||
                    boxDetails.editStatus
                  }
                  placeholder="Enter the email"
                  inputData={boxDetails.notifyEmails}
                  onChange={this.onEmailsChange.bind(this)}
                  validator={util.validateEmail}
                />
              </Col>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup row>
              <Label for="numbers" sm={6}>
                Notification number(s)
              </Label>
              <Col sm={12}>
                <MultiInput
                  disabledAdmin={
                    user.role === 'admin' ||
                    user.role === 'enterpriseAdmin' ||
                    boxDetails.editStatus
                  }
                  placeholder="Enter the number"
                  inputData={boxDetails.notifyNumbers}
                  onChange={this.onNumbersChange.bind(this)}
                />
              </Col>
            </FormGroup>
          </Col>
          {staticEmails && staticEmails.length > 0 && (
            <Col md={6} sm={12}>
              <div className="d-flex">
                <Label for="AlertContacts" sm={4} className="px-0">
                  Show Alert Contacts:
                </Label>
                <Col sm={4} style={{ padding: '5px' }}>
                  <Toggle
                    value={alertCompanyMails}
                    readOnly={boxDetails.editStatus}
                    onToggle={() => {
                      if (!alertCompanyMails) {
                        this.props.enableBulkBoxSession(
                          'Show Contacts Toggle changed from Diasbled to Enabled',

                          'alertContacts',
                        );
                      } else {
                        this.props.disableBulkBoxSession(
                          'Show Contacts Toggle changed from Enabled to Disabled',
                          'alertConatcts',
                        );
                      }
                      this.setState(
                        {
                          alertCompanyMails: !alertCompanyMails,
                        },
                        () => {
                          this.onFormFieldChange({
                            target: { name: 'alertCompanyMails', value: !alertCompanyMails },
                          });
                        },
                      );
                    }}
                  />
                </Col>
              </div>
              <Row>
                <Col md={6} sm={12}>
                  {alertCompanyMails &&
                    staticEmails.map(item => (
                      <div className="multi-input-item" key={item}>
                        <span className="item">{item}</span>
                      </div>
                    ))}
                </Col>
              </Row>
            </Col>
          )}
          <Col md={12} sm={12}>
            <hr />
          </Col>
          {/* commenting on purpose */}
          {/* {(user.role === 'companyGroupAdmin' || user.role === 'superAdmin') && (
            <Col md={4} sm={12}>
              <Button color="primary" onClick={() => this.setState({ shippingModal: true })}>
                Shipping and Tracking
              </Button>
            </Col>
          )}
          <Col md={12} sm={12}>
            <hr />
          </Col>
          */}
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup row>
              <Label for="emails" sm={6}>
                911 Notification Alert Email:
              </Label>
              <Col sm={12}>
                <MultiInput
                  disabledAdmin={
                    user.role === 'admin' ||
                    user.role === 'enterpriseAdmin' ||
                    boxDetails.editStatus
                  }
                  placeholder="Enter the email"
                  inputData={boxDetails.emergencyEmails}
                  onChange={this.on911EmailsChange.bind(this)}
                  validator={util.validateEmail}
                />
              </Col>
            </FormGroup>
          </Col>
          <Col md={6} >
            <FormGroup row>
              <Label for="numbers" sm={12}>
                911 Notification Alert SMS Text Number(s):
              </Label>
              <Col sm={12}>
                <MultiInput
                  disabledAdmin={
                    user.role === 'admin' ||
                    user.role === 'enterpriseAdmin' ||
                    boxDetails.editStatus
                  }
                  placeholder="Enter the number"
                  inputData={boxDetails.emergencyNumbers}
                  onChange={this.onEmergencyNumbersChange.bind(this)}
                />
              </Col>
            </FormGroup>
          </Col>
        </Row>
        {secondaryNotificationPerm ? (
          <>
            <Row>
              <Col md={3} sm={12}>
                <Toggle
                  readOnly={secondaryNotifyReadOnly}
                  left="Secondary Notification"
                  value={!!boxDetails.secondaryNotification}
                  onToggle={this.handleSecNotifyToggle}
                />
              </Col>
            </Row>
            {boxDetails.secondaryNotification ? (
              <Row>
                <Col md={6} sm={12}>
                  <FormGroup row>
                    <Col sm={8}>
                      <MultiInput
                        disabledAdmin={secondaryNotifyReadOnly}
                        placeholder="Enter the email"
                        inputData={boxDetails.secondaryNotifyEmails}
                        onChange={this.onSecondaryNotificationEmailsChange.bind(this)}
                        validator={util.validateEmail}
                      />
                    </Col>
                  </FormGroup>
                </Col>
                <Col md={6} sm={12}>
                  <FormGroup row>
                    <Col sm={8}>
                      <MultiInput
                        disabledAdmin={secondaryNotifyReadOnly}
                        placeholder="Enter the number"
                        inputData={boxDetails.secondaryNotifyNumbers}
                        onChange={this.onSecondaryNotificationNumbersChange.bind(this)}
                      />
                    </Col>
                  </FormGroup>
                </Col>
              </Row>
            ) : null}
          </>
        ) : null}

        <CustomModal
          isOpen={shippingModal}
          onCancel={() => this.setState({ shippingModal: false })}
        >
          <ShippingBox boxDetails={box} />
        </CustomModal>
        <DeleteLocationModal
          isOpen={removeModalStatus}
          onConfirm={() => this.onRemoveLocation()}
          onCancel={() => this.onCancelRemoveModal()}
          locationName={locationName}
        />

        <AddSecurityCodeModal
          isOpen={this.state.modalStatus}
          onCancel={() => {
            this.setState({ modalStatus: false });
          }}
          onConfirm={this.checkSecurityCode}
          // modalName='serialNumberUpdate'
          featureName={'serialNumberUpdate'}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  companies: state.AppState.companies,
  locations: state.AppState.boxDetails.boxLocations,
  box: state.AppState.boxDetails.box,
  deleteLocation: state.UIState.proposalEditor.deleteLocation,
  user: state.AppState.user,
  securityCode: state.UIState.users.addedUser.security,
});

const mapDispatchToProps = dispatch => ({
  onAddNewLocation: (token, cid, obj) => dispatch(onAddNewLocation(token, cid, obj)),
  onUpdateLocation: (token, cid, obj) => dispatch(onUpdateLocation(token, cid, obj)),
  updateBoxModelNumber: (token, vpnaddress) => dispatch(updateBoxModelNumber(token, vpnaddress)),
  onRemoveLocation: (token, id) => dispatch(onRemoveLocation(token, id)),
  getLocationByCompany: (token, cid) => dispatch(getLocationByCompany(token, cid)),
  changeBulkBoxSession: (description, key) => dispatch(changeBulkBoxSession(description, key)),
  disableAction: description => dispatch(disableAction(description)),
  enableAction: description => dispatch(enableAction(description)),
  disableBulkBoxSession: (description, key) => dispatch(disableBulkBoxSession(description, key)),
  enableBulkBoxSession: (description, key) => dispatch(enableBulkBoxSession(description, key)),
  getFirmwareVersion: (token, bid) => dispatch(getFirmwareVersion(token, bid)),
  setSuggestionCompany: (company) => dispatch(setSuggestionCompany(company))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateEpikBox);
